import { defineMessages } from 'react-intl';

const messages = defineMessages({
  header: {
    id: 'rewards.membershiptiers.header',
    description: 'Heading label for the Membership Tiers section',
    defaultMessage: 'Designed to Reward—Tier After Tier',
  },
  subheader: {
    id: 'rewards.membershiptiers.subheader',
    description: 'Subheading text for the Membership Tiers section',
    defaultMessage: 'There are plenty of easy ways to earn Stars.',
  },
  green: {
    id: 'rewards.membershiptiers.tier.green',
    description: 'Label for the Green tier',
    defaultMessage: 'Green',
  },
  gold: {
    id: 'rewards.membershiptiers.tier.gold',
    description: 'Label for the Gold tier',
    defaultMessage: 'Gold',
  },
  reserve: {
    id: 'rewards.membershiptiers.tier.reserve',
    description: 'Label for the Reserve tier',
    defaultMessage: 'Reserve',
  },
  benefitsList: {
    id: 'rewards.membershiptiers.benefits',
    description: 'Hidden header annoucing the tier benefits list',
    defaultMessage: '{tier} benefits list',
  },
  greenRange: {
    id: 'rewards.membershiptiers.tier.green.range',
    description: 'Text for the green tier star range',
    defaultMessage: 'Up to 499★ earned each year',
  },
  goldRange: {
    id: 'rewards.membershiptiers.tier.gold.range',
    description: 'Text for the gold tier star range',
    defaultMessage: 'Up to 1999★ earned each year',
  },
  reserveRange: {
    id: 'rewards.membershiptiers.tier.reserve.range',
    description: 'Text for the reserve tier star range',
    defaultMessage: '2000+★ earned each year',
  },
  greenPerkItem1: {
    id: 'rewards.membershiptiers.tier.green.perk1',
    description: 'Description of Green Tier perk 1',
    defaultMessage: 'Free Birthday treat, on your birthday',
  },
  greenPerkItem2: {
    id: 'rewards.membershiptiers.tier.green.perk2',
    description: 'Description of Green Tier perk 2',
    defaultMessage: 'Earn 1★ per every $1 spent',
  },
  greenPerkItem3: {
    id: 'rewards.membershiptiers.tier.green.perk3',
    description: 'Description of Green Tier perk 3',
    defaultMessage:
      'Mod Mondays—get a free customization, up to 12 times per year',
  },
  greenPerkItem4: {
    id: 'rewards.membershiptiers.tier.green.perk4',
    description: 'Description of Green Tier perk 4',
    defaultMessage: 'Personalized games & challenges',
  },
  greenPerkItem5: {
    id: 'rewards.membershiptiers.tier.green.perk5',
    description: 'Description of Green Tier perk 5',
    defaultMessage: 'Double Stars with personal cup',
  },
  goldPerkItem1: {
    id: 'rewards.membershiptiers.tier.gold.perk1',
    description: 'Description of Gold Tier perk 1',
    defaultMessage: 'Free Birthday treat, on your birthday',
  },
  goldPerkItem2: {
    id: 'rewards.membershiptiers.tier.gold.perk2',
    description: 'Description of Gold Tier perk 2',
    defaultMessage: 'Earn 1.2★ per every $1 spent',
  },
  goldPerkItem3: {
    id: 'rewards.membershiptiers.tier.gold.perk3',
    description: 'Description of Gold Tier perk 3',
    defaultMessage: 'Your Stars will never expire',
  },
  goldPerkItem4: {
    id: 'rewards.membershiptiers.tier.gold.perk4',
    description: 'Description of Gold Tier perk 4',
    defaultMessage:
      'Mod Mondays—get a free customization, up to 12 times per year',
  },
  goldPerkItem5: {
    id: 'rewards.membershiptiers.tier.gold.perk5',
    description: 'Description of Gold Tier perk 5',
    defaultMessage: 'Personalized games & challenges',
  },
  goldPerkItem6: {
    id: 'rewards.membershiptiers.tier.gold.perk6',
    description: 'Description of Gold Tier perk 6',
    defaultMessage: 'Double Stars with personal cup',
  },
  goldPerkItem7: {
    id: 'rewards.membershiptiers.tier.gold.perk7',
    description: 'Description of Gold Tier perk 7',
    defaultMessage: 'Receive a physical Gold Card',
  },
  reservePerkItem1: {
    id: 'rewards.membershiptiers.tier.reserve.perk1',
    description: 'Description of Reserve Tier perk 1',
    defaultMessage: 'Free Birthday treat, on your birthday',
  },
  reservePerkItem2: {
    id: 'rewards.membershiptiers.tier.reserve.perk2',
    description: 'Description of Reserve Tier perk 2',
    defaultMessage: 'Earn 1.7★ per every $1 spent',
  },
  reservePerkItem3: {
    id: 'rewards.membershiptiers.tier.reserve.perk3',
    description: 'Description of Reserve Tier perk 3',
    defaultMessage: 'Your Stars will never expire',
  },
  reservePerkItem4: {
    id: 'rewards.membershiptiers.tier.reserve.perk4',
    description: 'Description of Reserve Tier perk 4',
    defaultMessage:
      'Mod Mondays—get a free customization, up to 12 times per year',
  },
  reservePerkItem5: {
    id: 'rewards.membershiptiers.tier.reserve.perk5',
    description: 'Description of Reserve Tier perk 5',
    defaultMessage: 'Personalized games & challenges',
  },
  reservePerkItem6: {
    id: 'rewards.membershiptiers.tier.reserve.perk6',
    description: 'Description of Reserve Tier perk 6',
    defaultMessage: 'Double Stars with personal cup',
  },
  reservePerkItem7: {
    id: 'rewards.membershiptiers.tier.reserve.perk7',
    description: 'Description of Gold Tier perk 7',
    defaultMessage: 'Access to the Origin Collection',
  },
  reservePerkItem8: {
    id: 'rewards.membershiptiers.tier.reserve.perk8',
    description: 'Description of Reserve Tier perk 8',
    defaultMessage: 'Receive a physical, personalized Reserve Card',
  },
});

export default messages;
